import styles from './_RightSection.module.scss';
import BookmarkIcon from './images/bookmark-icon.svg';
import ExportIcon from './images/export-icon.svg';
import SampleProfile from './images/sample-profile-image.svg';
import ShareIcon from './images/share-icon.svg';
import WrenchIcon from './images/wrench-icon.svg';
import WrenchOnHoverIcon from './images/wrench-on-hover-icon.svg';
import SearchDropdown from 'components/search-dropdown/SearchDropdown';
import PropTypes from 'prop-types';
import { RM_SEARCH_LABEL } from 'constants/components';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectFiltersDisplayMapping,
    selectShowOverallAppOverlay,
    selectShowUserProfileOverlay,
    selectLoggedInUser
} from 'selectors/selectors';
import {
    toggleOverallAppOverlay,
    showUserProfileOverlay
} from 'slices/AppSlice';
import { useState } from 'react';

const RightSection = ({ navigateTo }) => {
    const dispatch = useDispatch();

    const [settingsIconHovered, setSettingsIconHovered] = useState(false);

    const showOverallAppOverlay = useSelector(selectShowOverallAppOverlay);
    const hasUserProfileOverlay = useSelector(selectShowUserProfileOverlay);
    const allValues = useSelector(selectFiltersDisplayMapping);
    const user = useSelector(selectLoggedInUser);

    const { rm: data } = { ...allValues };
    const sortedData = data
        ? data
              .reduce((acc, curr) => [...acc, { ...curr }], [])
              .filter((obj) => obj.value !== 0)
              .sort((a, b) => a.value - b.value)
        : [];

    const handleSettingsOnClick = () => dispatch(toggleOverallAppOverlay());
    const handleUserProfileOnClick = () => dispatch(showUserProfileOverlay());

    return (
        <div className={styles.rightSection}>
            <div className={styles.searchBox}>
                <SearchDropdown
                    label={RM_SEARCH_LABEL}
                    data={sortedData}
                    navigateTo={navigateTo}
                />
            </div>
            <div className={styles.iconsMenu}>
                <img src={BookmarkIcon} alt={''} className={styles.icon} />
                <img src={ExportIcon} alt={''} className={styles.icon} />
                <img src={ShareIcon} alt={''} className={styles.icon} />
                <div
                    className={
                        showOverallAppOverlay
                            ? styles.hoveredSettingsIconContainer
                            : styles.settingsIconContainer
                    }
                    onClick={handleSettingsOnClick}
                    onMouseOver={() => setSettingsIconHovered(true)}
                    onMouseOut={() => setSettingsIconHovered(false)}
                >
                    <img
                        src={
                            settingsIconHovered ? WrenchOnHoverIcon : WrenchIcon
                        }
                        alt={''}
                    />
                    {(showOverallAppOverlay || settingsIconHovered) && (
                        <span className={styles.settingsText}>Settings</span>
                    )}
                </div>
            </div>
            <div
                className={
                    hasUserProfileOverlay
                        ? styles.hoveredNotifications
                        : styles.notifications
                }
                onClick={handleUserProfileOnClick}
            >
                <img src={SampleProfile} alt={''} />
                <div className={styles.profileContainer}>
                    <div className={styles.upperText}>
                        {user ? user.name : 'John Doe'}
                    </div>
                    <div className={styles.lowerText}>
                        Risk Manager, Singapore
                    </div>
                </div>
            </div>
        </div>
    );
};

RightSection.propTypes = {
    navigateTo: PropTypes.func
};

export default RightSection;
